import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { Category } from '../models';

export enum CategoryActionTypes {
  ToggleCategoryPageLoading = '[Category] Toggle Category Page Loading',
  ToggleCategoryActionLoading = '[Category] Toggle Category Action Loading',
  RequestCategoryPage = '[Category] Request Category Page',
  LoadCategoryPage = '[Category] Load Category Page',
  CancelCategoryPage = '[Category] Cancel Category Page',
  CreateCategory = '[Category] Create Category',
  CreateCategoryOnServer = '[Category] Create Category On Server',
  UpdateCategory = '[Category] Update Category',
  UpdateCategoryOnServer = '[Category] Update Category On Server',
  ThrowCategoryError = '[Category] Throw Category Error',
  ClearCategoryError = '[Category] Clear Category Error',
}

export class ToggleCategoryPageLoading implements Action {
  readonly type = CategoryActionTypes.ToggleCategoryPageLoading;

  constructor(public payload: { pageLoading: boolean }) {}
}

export class ToggleCategoryActionLoading implements Action {
  readonly type = CategoryActionTypes.ToggleCategoryActionLoading;

  constructor(public payload: { actionLoading: boolean }) {}
}

export class RequestCategoryPage implements Action {
  readonly type = CategoryActionTypes.RequestCategoryPage;

  constructor(public payload: { query: QueryParamsModel }) {}
}

export class LoadCategoryPage implements Action {
  readonly type = CategoryActionTypes.LoadCategoryPage;

  constructor(
    public payload: { categories: Category[]; totalCount: number; query: QueryParamsModel },
  ) {}
}

export class CancelCategoryPage implements Action {
  readonly type = CategoryActionTypes.CancelCategoryPage;
}

export class CreateCategory implements Action {
  readonly type = CategoryActionTypes.CreateCategory;

  constructor(public payload: { category: Category }) {}
}

export class CreateCategoryOnServer implements Action {
  readonly type = CategoryActionTypes.CreateCategoryOnServer;

  constructor(public payload: { category: Category }) {}
}

export class UpdateCategory implements Action {
  readonly type = CategoryActionTypes.UpdateCategory;

  constructor(public payload: { category: Update<Category> }) {}
}

export class UpdateCategoryOnServer implements Action {
  readonly type = CategoryActionTypes.UpdateCategoryOnServer;

  constructor(public payload: { category: Category }) {}
}

export class ThrowCategoryError implements Action {
  readonly type = CategoryActionTypes.ThrowCategoryError;

  constructor(public payload: { error: any }) {}
}

export class ClearCategoryError implements Action {
  readonly type = CategoryActionTypes.ClearCategoryError;
}

export type CategoryActions =
  | ToggleCategoryPageLoading
  | ToggleCategoryActionLoading
  | RequestCategoryPage
  | LoadCategoryPage
  | CancelCategoryPage
  | CreateCategory
  | CreateCategoryOnServer
  | UpdateCategory
  | UpdateCategoryOnServer
  | ThrowCategoryError
  | ClearCategoryError;
